export default "__VITE_ASSET__ae524ab9__"